import { IReportCatalogSummaryProps } from '../pages/catalog/ReportCatalogSummary';
import {
  IEmbedReportFilterProps,
  IEmbedReportPageProps,
  IEmbedReportProps,
  IEmbedTagProps,
  IMarketProps,
  IRequestAccessPageProps,
  ISectionProps,
} from './GraphQLTypes';
export type EntityTypeProps =
  | IEmbedReportFilterProps
  | IEmbedReportPageProps
  | IRequestAccessPageProps
  | IEmbedReportProps
  | IMarketProps
  | ISectionProps
  | IEmbedTagProps
  | IReportCatalogSummaryProps;

export enum EntityType {
  EmbedReportFilter,
  EmbedReportPage,
  Mam,
  AccessRequest,
  EmbedReport,
  Market,
  Section,
  EmbedTag,
  ReportCatalogSummary,
  SecurityGroup,
}
